import {
  alertMessagesArgsConfig,
  browserStorageArgsConfig,
  collectionArgsConfig,
  consoleLogArgsConfig,
  browserDataArgs,
  collectionFieldArgsConfig,
} from '../utils/event_constants';

export const collectionActions = [
  {
    name: 'saveCollection',
    label: 'Save Data',
    args: [
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Request',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'updateCollection',
    label: 'Update Data',
    args: [
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'saveCollectionDraft',
    label: 'Save Data as Draft',
    args: [
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Request',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'resetFormData',
        label: 'Reset Form Data On Save',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'updateCollectionDraft',
    label: 'Update Data as Draft',
    args: [
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'resetFormData',
        label: 'Reset Form Data On Update',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'saveCollectionWithReferenceItems',
    label: 'Save Collection + Reference items',
    args: [
      collectionArgsConfig,
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'createReferenceFields',
        label: 'Do you want to Create Reference items?',
        type: 'boolean',
        value: '',
      },
      {
        name: 'collectionRefFields',
        label: 'Collection Reference Fields',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
      {
        name: 'saveReferenceItemsToSession',
        label: 'Save Reference Item In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'referenceItemSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'referenceItemSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'updateCollectionWithReferenceItems',
    label: 'Update Collection + Reference items',
    args: [
      collectionArgsConfig,
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'createReferenceFields',
        label: 'Do you want to Create Reference items?',
        type: 'boolean',
        value: '',
      },
      {
        name: 'collectionRefFields',
        label: 'Collection Reference Fields',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
      {
        name: 'saveReferenceItemsToSession',
        label: 'Save Reference Item In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'referenceItemSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'referenceItemSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'bulkUpdateCollection',
    label: 'Bulk Update Data',
    args: [
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'skipEmptyValues',
        label: 'Skip Empty Values (Only updates non-empty fields)',
        type: 'boolean',
        value: '',
        custom: [],
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'updateCollectionOnPageLoad',
    label: 'Update Collection Field',
    args: [
      collectionArgsConfig,
      {
        name: 'updateFindBy',
        label: 'Update Collection By',
        type: 'dropdown',
        options: [],
        value: 'byCollectionUuid',
      },
      {
        name: 'updateFindByResponseKeyForValue',
        label: 'Update Collection Find Response Key',
        type: 'text',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'deleteCollectionItem',
    label: 'Delete Data',
    args: [
      collectionArgsConfig,
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'addToCollectionItem',
    label: 'Add Data To Collection Field',
    args: [
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'cloneCollectionItem',
    label: 'Clone Collection Item',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'displayField' }),
      collectionFieldArgsConfig({ name: 'excludeFields', multi: true }),
      ...alertMessagesArgsConfig,
      ...browserDataArgs,
    ],
  },
  {
    name: 'removeFromCollectionItem',
    label: 'Remove Data From Collection Field',
    args: [
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'dependentDropDownPopulateOnChange',
    label: 'Create Dependent Dropdown',
    args: [
      collectionArgsConfig,
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'formPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'sourcePageApi',
        options: [],
        value: '',
      },
      {
        name: 'pageComponent',
        label: 'Select Form Component',
        type: 'dropdown',
        optionsType: 'pageFormComponent',
        options: [],
        value: '',
      },
      {
        name: 'onChangeElementName',
        label: 'On Change Element Name',
        type: 'dropdown',
        optionsType: 'pageCollectionFormComponent',
        value: '',
      },
      {
        name: 'valuesToChangeElementName',
        label: 'Values To Change Element Name',
        type: 'dropdown',
        optionsType: 'pageCollectionFormComponent',
        value: '',
      },
      {
        name: 'changeValuesCollection',
        label: 'Change Value Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      collectionFieldArgsConfig({}),
    ],
  },
  {
    name: 'updateCurrentLoggedInUserData',
    label: 'Update Current Logged In User',
    args: [
      {
        name: 'constructor',
        label: 'Constructor (Optional)',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'removeCollectionFieldData',
    label: 'Remove Collection Field Data',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fields', multi: true }),
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'saveCollectionAssets',
    label: 'Save Collection Assets',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'collectionField' }),
      collectionFieldArgsConfig({ name: 'belongsToField', label: 'Belongs To Field' }),
      {
        name: 'singleAssets',
        label: 'Save As Single Object',
        type: 'boolean',
        value: '',
        custom: [],
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'updateCollectionAssets',
    label: 'Update Collection Assets',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'collectionField' }),
      collectionFieldArgsConfig({ name: 'belongsToField', label: 'Belongs To Field' }),
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'pdfToText',
    label: 'PDF to Text',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fieldForPdf', label: 'Select PDF Field' }),
      collectionFieldArgsConfig({ name: 'fieldForText', label: 'Field to Save Extracted Text' }),
      ...alertMessagesArgsConfig,
      {
        name: 'sendItemIdFrom',
        label: 'Send Item ID From',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: 'sendCurrentObjectID',
      },
      {
        name: 'bslCollection',
        label: 'Item Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'itemIdBSLKey',
        label: 'Item ID JSON Key',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'anyFileToText',
    label: 'AnyFile to Text',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fieldForPdf', label: 'Select PDF Field' }),
      collectionFieldArgsConfig({ name: 'fieldForText', label: 'Field to Save Extracted Text' }),
      ...alertMessagesArgsConfig,
      {
        name: 'sendItemIdFrom',
        label: 'Send Item ID From',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: 'sendCurrentObjectID',
      },
      {
        name: 'bslCollection',
        label: 'Item Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'itemIdBSLKey',
        label: 'Item ID JSON Key',
        type: 'text',
        value: '',
      },
    ],
  },
];
